'use client';

import { useState, FormEvent } from 'react';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { useLogo } from '@/components/AppSettingsProvider';

function LoginForm() {
  const searchParams = useSearchParams();
  const next = searchParams.get('next') || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const logoLogin = useLogo('login');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Error al iniciar sesión');
        setLoading(false);
        return;
      }
      // Hard reload: garantiza que el AuthProvider se monte con la cookie nueva
      // y que el middleware deje pasar la nueva ruta protegida.
      window.location.href = next;
    } catch {
      setError('No se pudo conectar al servidor');
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      background: 'var(--bg-primary)',
    }}>
      <form
        onSubmit={handleSubmit}
        className="card"
        style={{
          width: '100%',
          maxWidth: '380px',
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          boxShadow: '0 0 20px rgba(0, 245, 255, 0.15)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
          {logoLogin ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img src={logoLogin} alt="Logo" style={{ maxHeight: '80px', maxWidth: '100%', margin: '0 auto', display: 'block' }} />
          ) : (
            <>
              <div style={{ fontSize: '2.5rem' }}>⚡</div>
              <h1 className="neon-text-cyan" style={{ fontSize: '1.4rem', fontWeight: 700, margin: '0.5rem 0 0', letterSpacing: '0.05em' }}>
                Team Dashboard
              </h1>
            </>
          )}
          <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', margin: '0.5rem 0 0' }}>
            Inicia sesión para continuar
          </p>
        </div>

        {error && (
          <div className="alert-error" style={{ fontSize: '0.85rem' }}>
            {error}
          </div>
        )}

        <label style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
          <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Email
          </span>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
          <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Contraseña
          </span>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          style={{
            background: 'rgba(0, 245, 255, 0.12)',
            color: 'var(--neon-cyan)',
            border: '1px solid var(--neon-cyan)',
            borderRadius: '8px',
            padding: '0.7rem',
            fontSize: '0.9rem',
            fontWeight: 700,
            letterSpacing: '0.05em',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            boxShadow: '0 0 10px rgba(0, 245, 255, 0.3)',
            textShadow: '0 0 6px rgba(0, 245, 255, 0.6)',
            marginTop: '0.5rem',
          }}
        >
          {loading ? 'INGRESANDO...' : 'INGRESAR'}
        </button>
      </form>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={<div style={{ padding: '2rem', color: 'var(--text-muted)' }}>Cargando...</div>}>
      <LoginForm />
    </Suspense>
  );
}
